// 스텝2 세율·요건 판정 순수 로직 — 스펙 2026-07-19 §4·§6·§7.
// rates-summary(fta=1) codes 를 속견표 엔진 computeApplicableRates 에 그대로 투입.
import { computeApplicableRates } from "./originToFta";

/** 신고세번+후보 union(distinct, 캡500 신고 우선) — rates-summary·req-customs 조회 대상. */
export function collectJudgmentHsks(results, groups, editedHsk, extraHsks) {
  const out = [];
  const seen = new Set();
  const push = (h) => {
    const s = String(h ?? "");
    if (/^\d{10}$/.test(s) && !seen.has(s) && out.length < 500) {
      seen.add(s);
      out.push(s);
    }
  };
  (results || []).forEach((r) => {
    const rep = groups?.[r.idx]?.members?.[0] ?? r.idx;
    push((editedHsk && editedHsk.get(rep)) || r.finalHsk || "");
  });
  (results || []).forEach((r) => {
    push(r.evidenceHsk);
    push(r.geminiHsk);
    push(r.masterHsk);
    push(r.simHsk);
  });
  (extraHsks || []).forEach(push);
  return out;
}

/** 후보 세번 1건의 판정 표시 정보. origin=resolveOrigin 결과(null=FTA Y/N 폴백).
 *  low = 적용 가능 최저세율(COO 해석 시 recommended, 아니면 무증빙 최저) — rateSpread 입력. */
export function judgeCandidate(hsk, ratesMap, reqFlags, origin) {
  const r = ratesMap ? ratesMap[hsk] : null;
  const rateText =
    r && r.rate !== undefined && r.rate !== null && r.rate !== ""
      ? `${r.rate} (${r.code})`
      : "";
  let ftaValue = null;
  let low = r && typeof r.rate === "number" ? r.rate : null;
  if (origin && r && r.codes) {
    const res = computeApplicableRates(r.codes, origin);
    const ftas = (res.applicable || []).filter(
      (a) => a.kind === "fta" && a.value != null,
    );
    if (ftas.length)
      ftaValue = ftas.reduce((m, a) => (a.value < m.value ? a : m)).value;
    if (res.recommended && res.recommended.value != null)
      low = res.recommended.value;
  }
  const im = (reqFlags && reqFlags[hsk] && reqFlags[hsk].im) || null;
  const reqText =
    im === "customs" ? "세관장" : im === "notice" ? "공고" : im ? "요건" : "";
  return {
    rateText,
    ftaValue,
    ftaFallback: r && r.fta === "Y" ? "Y" : "",
    reqText,
    reqLevel: im,
    low,
  };
}

/** 후보들 적용최저가 갈리면 {min,max}(주황 배지용), 아니면 null. */
export function rateSpread(judged) {
  const lows = (judged || [])
    .map((c) => c && c.low)
    .filter((v) => typeof v === "number");
  if (lows.length < 2) return null;
  const min = Math.min(...lows);
  const max = Math.max(...lows);
  return max > min ? { min, max } : null;
}
